import { render, staticRenderFns } from "./AdminContabilitaInviaView.vue?vue&type=template&id=0c029d32&"
import script from "./AdminContabilitaInviaView.vue?vue&type=script&lang=ts&"
export * from "./AdminContabilitaInviaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports